import { render, staticRenderFns } from "./FolderContentView.vue?vue&type=template&id=53e2b940"
import script from "./FolderContentView.vue?vue&type=script&lang=js"
export * from "./FolderContentView.vue?vue&type=script&lang=js"
import style0 from "./FolderContentView.vue?vue&type=style&index=0&id=53e2b940&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports